var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamsPopupTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15537",
    "data-name": "Group 15537",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.08,
    height: 16.504,
    viewBox: "0 0 17.08 16.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8144",
    "data-name": "Rectangle 8144",
    width: 17.08,
    height: 16.504,
    transform: "translate(0 0)",
    fill: "#3acb27"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15536",
    "data-name": "Group 15536",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5366",
    "data-name": "Path 5366",
    d: "M16.608,3.659,7.383,15.882a1.383,1.383,0,0,1-2.311,0l-4.6-6.1a2.729,2.729,0,0,1,0-3.062,1.383,1.383,0,0,1,2.311,0l3.466,4.593L14.316.623a1.383,1.383,0,0,1,2.311,0,2.722,2.722,0,0,1-.02,3.036",
    transform: "translate(0 0)",
    fill: "#3acb27",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsPopupTick);
export default __webpack_public_path__ + "static/media/teams-popup-tick.f3e90cd9cd00d1676195e0725397bb54.svg";
export { ForwardRef as ReactComponent };